import { DropdownButton, DropdownMenuItem, Styles } from "@mixitone/components";
import CogIcon from "@mixitone/icons/cog.svg";
import { ApplicationView } from "@mixitone/mvc";
import { AppController } from "controllers/AppController";

const SettingsMenu = () => {
  const appController = AppController.use();
  const { currentClub } = appController.state;

  return (
    <DropdownButton
      className="settings-menu"
      buttonComponent="button"
      buttonProps={{
        className: Styles.Buttons.buttonClasses({ kind: "topNav" }),
        style: { height: "var(--mixitone-header-height)" },
        title: "Settings menu",
        "aria-label": "Settings menu",
        "data-testid": "settings-menu",
      }}
      button={
        <div className="relative">
          <CogIcon className="h-5 w-5 stroke-white hover:stroke-slate-300" />
        </div>
      }
      dropdownTitle="Settings"
      arrow
    >
      <DropdownMenuItem
        value="profile"
        closeOnClick
        onClick={() => appController.actionForward("/settings/profile")}
      >
        Profile
      </DropdownMenuItem>
      {currentClub?.id && (
        <DropdownMenuItem
          value="club"
          closeOnClick
          onClick={() =>
            appController.actionForward("/settings/clubs/:clubId", {
              params: { clubId: currentClub.id! },
            })
          }
        >
          Club settings
        </DropdownMenuItem>
      )}
      <DropdownMenuItem
        value="account"
        closeOnClick
        onClick={() => appController.actionForward("/settings/account")}
      >
        Account
      </DropdownMenuItem>
    </DropdownButton>
  );
};

export default ApplicationView(SettingsMenu);
